export default "__VITE_ASSET__CT4y7XfR__"